import { useSearchParams } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';
import { SocialTabNav } from '../components/SocialTabNav';
import { SocialSetupPage } from '../setup/SocialSetupPage';
import { SocialWebhooksPage } from '../webhooks/SocialWebhooksPage';
import { SOCIAL_PLATFORMS } from '../config/platformCapabilities';
import { Link } from 'react-router-dom';

const TABS = [
  { id: 'integrations', label: 'Integrations', to: '/social/settings?tab=integrations' },
  { id: 'webhooks', label: 'Webhooks', to: '/social/settings?tab=webhooks' },
  { id: 'brands', label: 'Brands', to: '/social/settings?tab=brands' },
  { id: 'platforms', label: 'Platform workspaces', to: '/social/settings?tab=platforms' },
];

export function SocialSettingsHubPage() {
  const [params] = useSearchParams();
  const tab = params.get('tab') ?? 'integrations';

  return (
    <div>
      <PageHeader
        title="Social Settings"
        description="API keys, webhooks, brands, and shortcuts to platform workspaces. Connect channels in Connection Center."
        breadcrumbs={[{ label: 'Social', to: '/social' }, { label: 'Settings' }]}
      />
      <SocialTabNav tabs={TABS} className="mb-4" />

      {tab === 'channels' && (
        <p className="text-sm">
          Manage connected accounts in the{' '}
          <Link to="/social/connect?tab=channels" className="text-link font-medium">
            Connection Center → Connected Channels
          </Link>
          .
        </p>
      )}
      {tab === 'integrations' && <SocialSetupPage embedded tab="integrations" />}
      {tab === 'webhooks' && <SocialWebhooksPage embedded />}
      {tab === 'brands' && <SocialSetupPage embedded tab="brands" />}
      {tab === 'platforms' && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {SOCIAL_PLATFORMS.map((p) => (
            <Link
              key={p.id}
              to={`/social/platforms/${p.id}`}
              className="card p-4 text-sm font-medium hover:ring-2 hover:ring-primary-500/30"
            >
              {p.label} workspace →
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
